import Seo from "../lib/Seo";
import useReveal from "../lib/useReveal";
import { Arrow } from "../components/Icons";
import { JOTFORM_URL } from "../lib/api";

export default function Research() {
  useReveal();
  return (
    <>
      <Seo
        title="The Research | Dialed In"
        description="Dialed In is being shaped by real golfers. Share why you play, what you carry and what your best rounds feel like — and help shape the brand and products."
      />
      <section className="page-head" data-testid="research-page">
        <div className="wrap">
          <div className="label rv rv-up">The research</div>
          <h1 className="disp page-h rv rv-up">Built from real golfers, <span className="g">not guesses.</span></h1>
          <p className="page-sub rv rv-up">
            Before Dialed In sells anything, it listens. The products, the science and the brand are being shaped by honest conversations with golfers about what actually happens out there.
          </p>
        </div>
      </section>

      <section className="sec sec-2" data-testid="research-why">
        <div className="wrap">
          <div className="label rv rv-up">Why we're doing this</div>
          <div className="body-copy rv rv-up" style={{ maxWidth: 640, marginTop: "4vh" }}>
            <p>Most golf products start with a formula and go looking for customers. We started with questions.</p>
            <p><strong>Why do you play? What do you arrive carrying? What do your best rounds feel like? What happens when the game starts slipping away? And what helps you feel like yourself again?</strong></p>
            <p>Every answer shapes what Prepare, Reset, Sustain and Recover become — and what this brand builds around them.</p>
          </div>

          <div className="verse rv rv-up" style={{ marginTop: "6vh" }}>
            <p>It takes a few minutes.</p>
            <p>There are no wrong answers.</p>
            <p><strong>And it genuinely changes what we build.</strong></p>
          </div>

          <div className="rv rv-up" style={{ marginTop: "6vh" }}>
            <a className="cta" href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" data-testid="research-jotform-cta">
              Take Part in the Research <Arrow />
            </a>
            <p className="form-fine">Opens our research form. Your answers may be quoted anonymously — never with your name.</p>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="research-what-happens">
        <div className="wrap">
          <div className="label rv rv-up">What happens with your answers</div>
          <div className="moments" style={{ marginTop: "5vh" }}>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-prepare)" }} />Read</div>
              <p className="moment-copy">Every response is read by Jason. Not a research agency. Not an AI summary. The founder.</p>
            </div>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-reset)" }} />Shape</div>
              <p className="moment-copy">Patterns in what golfers carry and need directly shape the four products and the order we build them in.</p>
            </div>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-sustain)" }} />Share</div>
              <p className="moment-copy">The most useful findings get shared back with the community in The Science &middot; Weekly — anonymised, always.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
